import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default function callRiderViewApi(job_id, component) {
  const Authorization = "bearer " + localStorage.getItem("token");
  fetch(`${API_URL}rest/V1/rider/getOrdersByJobId/${job_id}/pending`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    // body: JSON.stringify({ rider_id, trip_id })
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("callRiderViewApi", data);
      if (data) {
        component.setState({
          acceptresult: data,
          loader: false,
        });
        // component.props.actionProcessingJobs(data[0].data);
      }
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/callRiderViewApi.js